export default __webpack_public_path__ + "static/media/039-roundabout.e35a3904.png";